export const SHOW_COMPLETE_GROUPS = "SHOW_COMPLETE_GROUPS";

export const changeShouldShowCompleteGroups = (shouldShowCompleteGroups) => ({
  type: SHOW_COMPLETE_GROUPS,
  payload: {
    shouldShowCompleteGroups
  }
});
